$( document ).ready(function() {
  var Style_withpageload = localStorage.getItem('lastAddedProductId');
  // console.log(Style_withpageload,'Style_withpageload...');
  if(Style_withpageload){
    $('.style-with-product').hide();
  }else{
    $('.style-with-product').show();
  }

  var Guarantee_check = localStorage.getItem('GuaranteeIdId');
  if(Guarantee_check){
    $('.Guarantee_btn_check').trigger('click'); 
  }


});
  $(document).on('click', '.style_withcart', function() {
    var styleproductId = $(this).attr('data-id');
     var data = {
          quantity: 1,
          id: styleproductId
      };
  
      $.ajax({
          type: 'POST',
          url: '/cart/add.js', // Shopify's AJAX API endpoint for adding items to the cart
          data: data,
          dataType: 'json',
          success: function(cart) {
             console.log('cart:', cart);
            
              $('.style-with-product').hide();
              // Store the product ID in localStorage
              localStorage.setItem('lastAddedProductId', styleproductId);

              // update giftcard quantity
            
              $("cart-drawer-items").load(location.href+" cart-drawer-items>*","");
              $(".cart-drawer__footer").load(location.href + " .cart-drawer__footer>*", "");
              $(".header__icon--cart").load(location.href + " .header__icon--cart>*", "");
            setTimeout(function(){
              var checkedValue = $('input[name="selected-product"]:checked').attr('data-product-id');
              var uncheckedValue = $('input[name="selected-product"]:not(:checked)').attr('data-product-id');
              console.log('redio button changed',checkedValue, uncheckedValue);
              
              addItem(checkedValue, 1);
            }, 1000);
          },
          error: function(xhr, status, error) {
              console.error('Error adding product to cart:', error);
          }
      });
  });

  function addItem(productId, proQtyValue) {
      var variantId = productId;
      var qty = proQtyValue;
    
      let formData = {
        items: [
          {
            id: variantId,
            quantity: qty,
          },
        ],
      };
      
      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          return response.json();
        })
        .then(function (response) {
          console.log('data',response);
           var uncheckedValue = $('input[name="selected-product"]:not(:checked)').attr('data-product-id');
           function removeItem() {
              let variantId = uncheckedValue;
              console.log('remove product',variantId);
              fetch("/cart/change.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  id: uncheckedValue,
                  quantity: 0,
                }),
              })
                .then((response) => {
                  if (!response.ok) {
                      throw new Error('Network response was not ok');
                  }
                  return response.json(); // Parse the JSON response
                })
                
                .catch((error) => {
                  console.error("Error: ", error);
                });
            }
          removeItem();
          $(".cart-drawer__footer").load(location.href + " .cart-drawer__footer>*", "");
          $("cart-drawer-items").load(location.href + " cart-drawer-items>*", "");
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }

// var checked_Value = $('.Guarantee_btn_check').attr('data-id');
//   setTimeout(function(){
//   var match_Found = false;
//   $("cart-remove-button").each(function() {
//           var CartID = $(this).attr('data-product-id');
//           console.log(CartID,'CartID');
//           if (checked_Value == CartID) {
//               match_Found = true; 
//               return false; 
//           }
//         });

//   if (match_Found) {
//       console.log("Match found...!");
//   } 
//   else {
//     console.log("No..Match found...!");
//     $('.Guarantee_btn_check').trigger('click');
//   }
// }, 500);


$(document).on('click', '.Guarantee_btn_check', function() {
  var checked_Value = $(this).attr('data-id');
  setTimeout(function(){
  var match_Found = false;
  $("cart-remove-button").each(function() {
          var CartID = $(this).attr('data-product-id');
          console.log(CartID,'CartID');
          if (checked_Value == CartID) {
              match_Found = true; 
              return false; 
          }
        });

  if (match_Found) {
      console.log("Match found...!");
  } 
  else {
     console.log("no Match found...!",this);
    setTimeout(function(){
    if ($('.Guarantee_btn_check').is(':checked')) {
      var GuaranteeId = $('.Guarantee_btn_check').attr('data-id');
       var data = {
            quantity: 1,
            id: GuaranteeId
        };
    
        $.ajax({
            type: 'POST',
            url: '/cart/add.js', // Shopify's AJAX API endpoint for adding items to the cart
            data: data,
            dataType: 'json',
            success: function(cart) {
                $("cart-drawer-items").load(location.href+" cart-drawer-items>*","");
                 $(".cart-drawer__footer").load(location.href + " .cart-drawer__footer>*", "");
                // Store the product ID in localStorage
                localStorage.setItem('GuaranteeIdId', GuaranteeId);
                $(".header__icon--cart").load(location.href + " .header__icon--cart>*", "");
            },
            error: function(xhr, status, error) {
                console.error('Error adding product to cart:', error);
            }
        });
    }
  }, 1000);
  }

   setTimeout(function(){
   if (!$('.Guarantee_btn_check').is(':checked')) {
    var Guarantee_Id = $('.Guarantee_btn_check').attr('data-id');
      var data = {
          quantity: 0,
          id: 43672119181471
      };
  
      $.ajax({
          type: 'POST',
          url: '/cart/change.js', // Shopify's AJAX API endpoint for adding items to the cart
          data: data,
          dataType: 'json',
          success: function(cart) {
              $("cart-drawer-items").load(location.href+" cart-drawer-items>*","");
               $(".cart-drawer__footer").load(location.href + " .cart-drawer__footer>*", "");
              // Store the product ID in localStorage
              localStorage.removeItem('GuaranteeIdId');
          },
          error: function(xhr, status, error) {
              console.error('Error adding product to cart:', error);
          }
      });
   }
   }, 500);

}, 500);
  
});